import type { GameComponentProps } from '../core/types';
import { FixtureGame } from '../fixture/FixtureGame';
import { PaireGame } from './PaireGame';

export function PaireEntry(props: GameComponentProps) {
  if (props.puzzle.generatorVersion < 2) return <FixtureGame {...props} />;
  return <PaireGame {...props} />;
}
